import { get } from "lodash-es";
import { useTemplatesContext } from "../context/templatesContext";
import { getShiftParameters } from "../repositories/TemplatesRepositorie";

type Props = {
	setIsParametersLoading: (isLoading: boolean) => void;
	setParametersError: (err: string) => void;
};

export const useLoadPeriodPerDay = ({
	setIsParametersLoading,
	setParametersError,
}: Props) => {
	const {
		state: { searchAssetIdToTable },
		actions,
	} = useTemplatesContext();
	return async () => {
		setIsParametersLoading(true);
		const res = await getShiftParameters(searchAssetIdToTable as number);
		if (res.ok) {
			const shifts = get(res, "data.tables[0].rows[0].ShiftCodes.length", null);
			actions.setShiftsPerDay(shifts);
			setIsParametersLoading(false);
		} else {
			setIsParametersLoading(false);
			setParametersError(res.message);
		}
	};
};
